const React = require("react")
const { Info } = require("./icons/info")
const { Lock } = require("./icons/lock")

module.exports = {
  Info: (props) => <Info {...props} />,
  Lock: (props) => <Lock {...props} />
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/prompt/index.js